// extracted by mini-css-extract-plugin
export default {"root":"FR5YTtQnYA","previousNext":"XGoE_h0TtO"};